import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { callUrlMapper } from "@/api/vercel";

export default function ShortRedirect() {
  const { shortCode } = useParams();

  useEffect(() => {
    const redirect = async () => {
      try {
        const res = await callUrlMapper({ action: "read" });
        const mappings = res?.data || [];
        const match = mappings.find((m) => (m.urlInput || m.id) === shortCode);
        const destination = match?.urlDestination;
        if (destination) {
          const base = `${window.location.origin}/`;
          const suffix = destination.startsWith("?")
            ? destination
            : destination.includes("=")
              ? `?${destination}`
              : destination;
          window.location.replace(`${base}${suffix}`);
          return;
        }
      } catch (e) {
        // ignore and fall back to home
      }
      window.location.replace("/");
    };
    redirect();
  }, [shortCode]);

  return (
    <div className="home-page-container">
      <div className="flex flex-col items-center justify-center container mx-auto px-4 py-8 bg-white">Redirecting...</div>
    </div>
  );
}


